<template>
  <!-- component -->
  <!-- This is an example component -->
  <div class="max-w-7xl mx-auto flex flex-col relative">

    <nav class="max-w-7xl px-5 md:fixed top-0 z-[98] w-screen backdrop-blur-md bg-[#121212] bg-opacity-80">
      <div class="container mx-auto flex flex-wrap items-center justify-between">
        <button @click="redirectToHome" class="flex">
          <span class="self-center text-lg text-[#ffdb70] font-semibold whitespace-nowrap fadein-bot hover:text-amber-100">BenHo();</span>
        </button>
        <div class="flex md:order-2 fadein-bot items-center gap-3">
          <!-- Language Switcher -->
          <button
            @click="toggleLanguage"
            class="lang-toggle text-gray-300 text-sm font-medium transition-colors px-2 py-1 rounded focus:outline-none"
            :title="currentLocale === 'de' ? 'Switch to English' : 'Auf Deutsch wechseln'">
            {{ currentLocale === 'de' ? 'EN' : 'DE' }}
          </button>
          <a href="https://github.com/Zerofour04"><img class="w-9 rounded-full" src="https://cdn.pixabay.com/photo/2022/01/30/13/33/github-6980894_960_720.png" alt="github"></a>
        </div>
        <div class="hidden md:flex justify-between items-center w-full md:w-auto md:order-1" id="mobile-menu-3">
          <ul class="flex-col md:flex-row flex md:space-x-8 mt-4 md:mt-0 md:text-sm md:font-medium">
            <li>
              <router-link to="/"
                class="fadein-bot text-gray-300 hover:bg-gray-50 border-b border-gray-100 md:hover:bg-transparent md:border-0 block pl-3 pr-4 py-2 md:hover:text-white md:p-0"
                aria-current="page">{{ $t('nav.home') }}</router-link>
            </li>
            <li>
              <router-link to="/about"
                class="fadein-bot fadein-1 text-gray-300 hover:bg-gray-50 border-b border-gray-100 md:hover:bg-transparent md:border-0 block pl-3 pr-4 py-2 md:hover:text-white md:p-0">{{ $t('nav.about') }}</router-link>
            </li>
            <li>
              <router-link to="/portfolio"
                class="fadein-bot fadein-2 text-gray-300 hover:bg-gray-50 border-b border-gray-100 md:hover:bg-transparent md:border-0 block pl-3 pr-4 py-2 md:hover:text-white md:p-0">{{ $t('nav.portfolio') }}</router-link>
            </li>
            <li>
              <router-link to="/blog"
                class="fadein-bot fadein-3 text-gray-300 hover:bg-gray-50 border-b border-gray-100 md:hover:bg-transparent md:border-0 block pl-3 pr-4 py-2 md:hover:text-white md:p-0 blog">{{ $t('nav.blog') }}</router-link>
            </li>
            <li>
              <router-link to="/contact"
                class="fadein-bot fadein-4 text-gray-300 hover:bg-gray-50 border-b border-gray-100 md:hover:bg-transparent md:border-0 block pl-3 pr-4 py-2 md:hover:text-white md:p-0">{{ $t('nav.contact') }}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div class="md:mt-[100px]">
      <router-view />
    </div>

    <!-- Cookie-Settings Button für Desktop -->
    <button
      @click="showCookieSettings"
      class="hidden md:flex fixed bottom-5 right-5 items-center gap-2 px-4 py-2 rounded-lg border border-[#383838] bg-[#1e1e1f] hover:bg-[#282828] text-gray-300 hover:text-white text-sm transition-all z-50"
      title="Cookie-Einstellungen">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
        <path d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM6.262 6.072a8.25 8.25 0 1010.562-.766 4.5 4.5 0 01-1.318 1.357L14.25 7.5l.165.33a.809.809 0 01-1.086 1.085l-.604-.302a1.125 1.125 0 00-1.298.21l-.132.131c-.439.44-.439 1.152 0 1.591l.296.296c.256.257.622.374.98.314l1.17-.195c.323-.054.654.036.905.245l1.33 1.108c.32.267.46.694.358 1.1a8.7 8.7 0 01-2.288 4.04l-.723.724a1.125 1.125 0 01-1.298.21l-.153-.076a1.125 1.125 0 01-.622-1.006v-1.089c0-.298-.119-.585-.33-.796l-1.347-1.347a1.125 1.125 0 01-.21-1.298L9.75 12l-1.64-1.64a6 6 0 01-1.676-3.257l-.172-1.03z"/>
      </svg>
      <span>Cookies</span>
    </button>
  </div>
  <footer class="block md:hidden fixed bottom-0 left-0 right-0 rounded-t-3xl border border-[#383838] bg-[#121212] bg-opacity-80 backdrop-blur-md backdrop-opacity-90">
  <nav class="flex justify-around py-4 text-xs">
    <router-link to="/" class="text-gray-300 hover:text-white">{{ $t('nav.home') }}</router-link>
    <router-link to="/about" class="text-gray-300 hover:text-white">{{ $t('nav.about') }}</router-link>
    <router-link to="/portfolio" class="text-gray-300 hover:text-white">{{ $t('nav.portfolio') }}</router-link>
    <router-link to="/blog" class="text-gray-300 hover:text-white">{{ $t('nav.blog') }}</router-link>
    <router-link to="/contact" class="text-gray-300 hover:text-white">{{ $t('nav.contact') }}</router-link>
    <button @click="showCookieSettings" class="text-gray-300 hover:text-white flex items-center gap-1">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
        <path d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z"/>
      </svg>
    </button>
  </nav>
</footer>
</template>

<script>
import { initCookieConsent, hasAnalyticsConsent, showCookiePreferences, setCookieConsentLanguage } from './plugins/cookieConsent'
import { enableAnalytics, disableAnalytics } from './plugins/analytics'
import { setLocale, getLocale } from './plugins/i18n'

export default {
  data() {
    return {
      currentLocale: getLocale()
    }
  },
  mounted() {
    // Cookie-Consent initialisieren
    initCookieConsent(
      () => {
        // Wird aufgerufen wenn User Analytics akzeptiert
        enableAnalytics()
      },
      () => {
        // Wird aufgerufen wenn User Analytics ablehnt
        disableAnalytics()
      }
    )

    // Falls User bereits zugestimmt hat, Analytics aktivieren
    if (hasAnalyticsConsent()) {
      enableAnalytics()
    }

    // HTML lang Attribut setzen
    document.documentElement.lang = this.currentLocale
  },
  methods: {
    redirectToHome() {
      this.$router.push('/')
    },
    showCookieSettings() {
      showCookiePreferences()
    },
    toggleLanguage() {
      const newLocale = this.currentLocale === 'de' ? 'en' : 'de'
      setLocale(newLocale)
      setCookieConsentLanguage(newLocale)
      this.currentLocale = newLocale
    }
  },
}
</script>

<style>
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

::-webkit-scrollbar {
  width: 5px; /* for vertical scrollbar */
  height: 5px; /* for horizontal scrollbar */
}

::-webkit-scrollbar-track {
  background: hsl(240, 1%, 17%);
  border-radius: 5px;
}

::-webkit-scrollbar-thumb {
  background: #ffdb70;
  border-radius: 5px;
}

::-webkit-scrollbar-button { width: 20px; }

body {
  font-family: 'Poppins', sans-serif;
  background: hsl(0, 0%, 7%);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #d1d5db;
  transition: color 0.3s;
}

nav a.router-link-exact-active {
  display: inline-flex;
  flex-direction: column;
  color: white;
  transition: color 0.3s;
}

nav a.router-link-exact-active::after {
  display: inline-block;
  content: "";
  margin-top: 0.08em;
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background-color: #ffdb70;
}

nav a.router-link-exact-active:hover {
  color: white;
}


@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translateX(-100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

/* ========================================
   Cookie Consent - Custom Dark Theme
   Passend zum Portfolio Design
   ======================================== */

/* Basis-Variablen überschreiben */
#cc-main {
  --cc-font-family: 'Poppins', sans-serif;
  --cc-modal-border-radius: 0.75rem;
  --cc-btn-border-radius: 0.5rem;
  --cc-toggle-border-radius: 1rem;

  /* Dark Theme Farben */
  --cc-bg: #1e1e1f;
  --cc-primary-color: #f5f5f5;
  --cc-secondary-color: #d1d5db;

  /* Buttons */
  --cc-btn-primary-bg: #ffdb70;
  --cc-btn-primary-color: #121212;
  --cc-btn-primary-border-color: #ffdb70;
  --cc-btn-primary-hover-bg: #ffd54f;
  --cc-btn-primary-hover-color: #121212;
  --cc-btn-primary-hover-border-color: #ffd54f;

  --cc-btn-secondary-bg: #282828;
  --cc-btn-secondary-color: #d1d5db;
  --cc-btn-secondary-border-color: #383838;
  --cc-btn-secondary-hover-bg: #333333;
  --cc-btn-secondary-hover-color: #ffffff;
  --cc-btn-secondary-hover-border-color: #484848;

  /* Toggle */
  --cc-toggle-on-bg: #ffdb70;
  --cc-toggle-off-bg: #383838;
  --cc-toggle-readonly-bg: #ffdb70;

  /* Sections & Borders */
  --cc-separator-border-color: #383838;
  --cc-cookie-category-block-bg: #282828;
  --cc-cookie-category-block-border: #383838;

  /* Overlay */
  --cc-overlay-bg: rgba(0, 0, 0, 0.7);

  /* Footer */
  --cc-footer-bg: #171717;
  --cc-footer-color: #9ca3af;
  --cc-footer-border-color: #383838;
}

/* Consent Modal Box */
#cc-main .cm {
  background: #1e1e1f;
  border: 1px solid #383838;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
}

/* Titel */
#cc-main .cm__title {
  color: #ffffff;
  font-weight: 600;
}

/* Beschreibung */
#cc-main .cm__desc {
  color: #d1d5db;
}

/* Buttons Container */
#cc-main .cm__btn-group {
  gap: 0.5rem;
}

/* Primary Button (Alle akzeptieren) */
#cc-main .cm__btn.cm__btn--primary {
  background: #ffdb70;
  color: #121212;
  font-weight: 600;
  border: none;
  transition: all 0.2s ease;
}

#cc-main .cm__btn.cm__btn--primary:hover {
  background: #ffd54f;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 219, 112, 0.3);
}

/* Secondary Buttons */
#cc-main .cm__btn:not(.cm__btn--primary) {
  background: #3a3a3a;
  color: #f0f0f0;
  border: 1px solid #4a4a4a;
  font-weight: 500;
  transition: all 0.2s ease;
}

#cc-main .cm__btn:not(.cm__btn--primary):hover {
  background: #454545;
  color: #ffffff;
  border-color: #5a5a5a;
}

/* Focus States für Keyboard-Navigation (Barrierefreiheit) */
#cc-main .cm__btn:focus-visible,
#cc-main .pm__btn:focus-visible,
#cc-main .pm__close-btn:focus-visible {
  outline: 2px solid #ffdb70;
  outline-offset: 2px;
}

#cc-main .toggle__input:focus-visible + .toggle__slider {
  outline: 2px solid #ffdb70;
  outline-offset: 2px;
}

#cc-main a:focus-visible {
  outline: 2px solid #ffdb70;
  outline-offset: 2px;
  border-radius: 2px;
}

/* Footer Links */
#cc-main .cm__footer {
  background: #171717;
  border-top: 1px solid #383838;
}

#cc-main .cm__footer a {
  color: #9ca3af;
  transition: color 0.2s ease;
}

#cc-main .cm__footer a:hover {
  color: #ffdb70;
}

/* ========================================
   Preferences Modal (Einstellungen)
   ======================================== */

#cc-main .pm {
  background: #1e1e1f;
  border: 1px solid #383838;
}

/* Header */
#cc-main .pm__header {
  background: #1e1e1f;
  border-bottom: 1px solid #383838;
}

#cc-main .pm__title {
  color: #ffffff;
  font-weight: 600;
}

/* Close Button */
#cc-main .pm__close-btn {
  background: #3a3a3a;
  border: 1px solid #4a4a4a;
  color: #f0f0f0;
  transition: all 0.2s ease;
}

#cc-main .pm__close-btn:hover {
  background: #454545;
  color: #ffffff;
  border-color: #5a5a5a;
}

/* Body */
#cc-main .pm__body {
  background: #1e1e1f;
}

/* Section Titles */
#cc-main .pm__section-title {
  color: #ffffff;
  font-weight: 600;
}

/* Section Descriptions */
#cc-main .pm__section-desc {
  color: #d1d5db;
}

#cc-main .pm__section-desc a {
  color: #ffdb70;
}

#cc-main .pm__section-desc a:hover {
  color: #ffd54f;
}

/* Badge (Immer aktiv) */
#cc-main .pm__badge,
#cc-main .pm__badge:hover,
#cc-main *:hover .pm__badge,
#cc-main .pm__section--expandable:hover .pm__badge,
#cc-main .pm__section-title-btn:hover .pm__badge {
  background: #ffdb70 !important;
  color: #121212 !important;
  font-weight: 600;
  padding: 0.15rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.7rem;
  display: inline-block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

/* Category Blocks */
#cc-main .pm__section--expandable {
  background: #282828 !important;
  border: 1px solid #383838;
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
}

#cc-main .pm__section--expandable:hover {
  background: #323232 !important;
  border-color: #484848;
}

/* Accordion - ALLE Hover-States überschreiben */
#cc-main .pm__section-title-btn,
#cc-main .pm__section-title-btn:hover,
#cc-main .pm__section-title-btn:focus,
#cc-main .pm__section-title-btn:active,
#cc-main .pm__section--expandable .pm__section-title-wrapper,
#cc-main .pm__section--expandable .pm__section-title-wrapper:hover,
#cc-main .pm__section--expandable:hover .pm__section-title-btn,
#cc-main .pm__section--expandable:hover .pm__section-title-wrapper,
#cc-main .pm *:hover,
#cc-main .pm__section *:hover {
  background: transparent !important;
  background-color: transparent !important;
}

/* Section Blocks behalten ihre Farbe */
#cc-main .pm__section--expandable,
#cc-main .pm__section--expandable:hover {
  background: #282828 !important;
}

#cc-main .pm__section--expandable:hover {
  background: #323232 !important;
}

/* Toggle Switch */
#cc-main .pm__section-title-wrapper .toggle__slider {
  background: #383838;
}

#cc-main .pm__section-title-wrapper .toggle__input:checked + .toggle__slider {
  background: #ffdb70 !important;
}

#cc-main .pm__section-title-wrapper .toggle__slider::before {
  background: #ffffff;
}

/* Readonly Toggle (Necessary Cookies) - immer gelb */
#cc-main .toggle__input:checked:disabled + .toggle__slider,
#cc-main .toggle__input[disabled]:checked + .toggle__slider,
#cc-main .section--necessary .toggle__slider,
#cc-main .toggle--readonly .toggle__slider {
  background: #ffdb70 !important;
}

/* Accordion Pfeile - nicht gelb */
#cc-main .pm__section-arrow,
#cc-main .pm__section-arrow::before,
#cc-main .pm__section-arrow::after,
#cc-main .pm__chevron {
  background: #9ca3af !important;
  border-color: #9ca3af !important;
}

/* Cookie Table */
#cc-main .pm__table {
  background: #1e1e1f;
  border: 1px solid #383838;
  border-radius: 0.375rem;
  overflow: hidden;
}

#cc-main .pm__table-head {
  background: #282828;
}

#cc-main .pm__table-th {
  color: #ffffff;
  font-weight: 600;
  border-bottom: 1px solid #383838;
}

#cc-main .pm__table-td {
  color: #d1d5db;
  border-bottom: 1px solid #383838;
}

#cc-main .pm__table-tr:last-child .pm__table-td {
  border-bottom: none;
}

/* Footer */
#cc-main .pm__footer {
  background: #171717;
  border-top: 1px solid #383838;
}

/* Toggle Icons entfernen */
#cc-main .toggle__icon-off,
#cc-main .toggle__icon-on {
  display: none !important;
}

/* Scrollbar im Modal */
#cc-main .pm__body::-webkit-scrollbar {
  width: 5px;
}

#cc-main .pm__body::-webkit-scrollbar-track {
  background: #282828;
}

#cc-main .pm__body::-webkit-scrollbar-thumb {
  background: #ffdb70;
  border-radius: 5px;
}

/* Animation */
#cc-main .cm,
#cc-main .pm {
  animation: ccFadeIn 0.3s ease;
}

@keyframes ccFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Reduzierte Bewegung für Nutzer mit Bewegungsempfindlichkeit */
@media (prefers-reduced-motion: reduce) {
  #cc-main .cm,
  #cc-main .pm {
    animation: none;
  }

  #cc-main .cm__btn,
  #cc-main .pm__btn {
    transition: none;
  }
}

/* ========================================
   Ende Cookie Consent Styles
   ======================================== */

/* Language Toggle - Hover nur auf Desktop */
.lang-toggle:active {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

@media (hover: hover) {
  .lang-toggle:hover {
    background: rgba(255, 255, 255, 0.1);
    color: white;
  }
}

</style>
